import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ReactTitle } from "react-meta-tags";
import { withTranslation } from "react-i18next";
import { getEnvironment } from "../../../../Redux/reducer/env";
import * as sessionActions from "../../../../Redux/actions/sessionActions";
import Chrome from "../../../../../static/images/chrome.png";
import Disclaimer from "../../Disclaimer/Disclaimer";
import Mozilla from "../../../../../static/images/mozilla.png";
import Explorer from "../../../../../static/images/explorer.svg";
import PaMap from "../../../../../static/images/paMap.svg";
import CrMap from "../../../../../static/images/crMap.svg";
import AppName from "../../../../../static/images/appName.png";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";
import { Link } from "react-router-dom";

export class Landing extends Component {
  componentDidMount() {
    this.props.actions.setPage("register");
  }

  render() {
    const { t } = this.props;

    return (
      <div className="wrapper-login">
        <ReactTitle title={`${t("appName")}`} />
        <header className="main-login-header">
          <div className="login-header-container">
            <div className="container-item">
              <img src={AppName} />
            </div>
            <div className="browser">
              <p className="title">{t("login.bottom.advertisingText")}</p>
              <p className="browser-supported">
                <img src={Explorer} alt="Navegadores soportados" />{" "}
                IE 11+
              </p>
              <p className="browser-supported">
                <img src={Mozilla} alt="Navegadores soportados" />{" "}
                Mozilla Firefox
              </p>
              <p className="browser-supported">
                <img src={Chrome} alt="Navegadores soportados" />{" "}
                Google Chrome
              </p>
            </div>
          </div>
        </header>
        <div className="landing-content">
          <div style={{ marginTop: 25 }}>
            <Disclaimer containerClass={"landing"}>
              <p>{t("disclaimer.split_text.text_1")}</p>
              <p>{t("disclaimer.split_text.text_2")}</p>
              <p>{t("disclaimer.split_text.text_3")}</p>
            </Disclaimer>
          </div>
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ marginTop: 30 }}
          >
            <div id="country-selector">
              <div className="title">
                <h3>
                  {t("landing.title")} <span>{t("appName")}</span>
                </h3>
                <div className="line red"></div>
              </div>
            </div>
            <div className="countries">
              <div className="country-container">
                <img
                  src={CrMap}
                  style={{ width: "120px", height: "200px", margin: "auto" }}
                />
                <img
                  src={PaMap}
                  style={{ width: "145px", height: "200px", margin: "auto" }}
                />
              </div>
              <h2>{t("appName")}</h2>
              <p className="country-p">
                {t("landing.country.CR")} & {t("landing.country.PA")}
              </p>
              <div className="line gray"></div>
              <div className="country-actions">
                <Link
                  id="clients"
                  to={{
                    pathname: "/clients/login",
                  }}
                >
                  <PrimaryButton className="button-country">
                    {t("landing.options.clients")}
                  </PrimaryButton>
                </Link>
                <Link
                  id="providers"
                  to={{
                    pathname: "/providers/login",
                  }}
                >
                  <PrimaryButton className="button-country">
                    {t("landing.options.suppliers")}
                  </PrimaryButton>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    env: getEnvironment(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
};
export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(Landing));
